/* eslint-disable camelcase */
import api from '@pray/shared/utils/api';

// Whether the leader is offered in the app's onboarding Follow Artists step, and what they lack to be shown there.
export type OnboardingLeaderResponse = {
  is_onboarding_leader: boolean;
  // Lists the leader ahead of the shuffled ones, lowest first; null when unpinned.
  priority: number | null;
  missing_fields: string[];
};

export async function getOnboardingLeader({ artistId }: { artistId: string }): Promise<OnboardingLeaderResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const response = await api.executeGetRequest<{ data: OnboardingLeaderResponse }>(
    `/web/studio/artists/${artistId}/onboarding-leader`
  );

  return response.data.data;
}

export async function updateOnboardingLeader({
  artistId,
  isOnboardingLeader,
  priority = undefined,
}: {
  artistId: string;
  isOnboardingLeader: boolean;
  // Left out, the leader keeps their current pin; null unpins.
  priority?: number | null;
}): Promise<OnboardingLeaderResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const response = await api.executePutRequest<{ data: OnboardingLeaderResponse }>(
    `/web/studio/artists/${artistId}/onboarding-leader`,
    {
      is_onboarding_leader: isOnboardingLeader,
      ...(priority !== undefined && { priority }),
    }
  );

  return response.data.data;
}
